import React from 'react';
import PropTypes from 'prop-types';
import { Button, Space } from 'antd';
import { EditFilled } from '@ant-design/icons';

const ActionButtons = ({ showEditBtn, onEditClick, onCancelClick }) => {
  return (
    <>
      {showEditBtn && (
        <Button type="link" size="middle" onClick={onEditClick}>
          <EditFilled />
          Edit
        </Button>
      )}
      {!showEditBtn && (
        <Space>
          <Button type="secondary" size="middle" onClick={onCancelClick}>
            Cancel
          </Button>
          <Button type="primary" size="middle" htmlType="submit">
            Update
          </Button>
        </Space>
      )}
    </>
  );
};

ActionButtons.defaultProps = {};

ActionButtons.propTypes = {
  showEditBtn: PropTypes.bool.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
};

export default ActionButtons;
